import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Arrow, Box, Diagram} from "../shared/Diagram"

export default function CachingAndInvalidation() {
    return (
        <TopicLayout
            title="Caching and invalidation"
            intro="Cache-aside: the application checks the cache first, and only reaches the source of truth on a miss — then stores what it found so the next read is fast."
            diagram={
                <Diagram viewBox="0 0 560 160">
                    <Box x={20} y={30} width={90} height={90} label="Client"/>
                    <Box x={230} y={30} width={90} height={90} label="Cache" accent/>
                    <Box x={440} y={30} width={100} height={90} label="Source"/>

                    <Arrow x1={110} y1={48} x2={230} y2={48} label="1. read"/>
                    <Arrow x1={320} y1={48} x2={440} y2={48} label="2. miss" dashed/>
                    <Arrow x1={440} y1={72} x2={320} y2={72} label="3. store (TTL)" muted/>
                    <Arrow x1={230} y1={96} x2={110} y2={96} label="4. return value"/>

                    <text x={280} y={144} textAnchor="middle" fontSize={11} opacity={0.7}>On a hit, steps 2 and 3 are skipped entirely</text>
                </Diagram>
            }
            useWhen={[
                'Reads greatly outnumber writes, recomputation or source reads are expensive, and a defined amount of staleness is acceptable.'
            ]}
            tradeOff="Cache-aside loads data on a miss and is a practical default; TTLs bound how long stale entries survive. Write-through updates a cache during writes, adding latency and another failure mode, but does not by itself guarantee fresh reads: concurrent writes, replicas, bypass paths and failed cache updates still need a consistency strategy."
            ruleOfThumb="Use cache-aside with a measured TTL first, document the source of truth and acceptable staleness, and add explicit invalidation only where the correctness benefit justifies it."
        />
    )
}
